import classNames from 'classnames';
import { ScommesseEsitoTipoBox } from 'components/scommesseEsitoTipoBox';
import { useInfoTipo, useIsAvvenimento } from 'features/sport/hooks';
import useWindowSize from 'hooks/useWindowSize';
import React, { useMemo } from 'react';
import { isTruthy } from 'utility/functions';
import styles from './RecursiveEsitoList.module.scss';

export type RecursiveEsitoListProps = {
  hasTitleHeader: boolean;
  scommessaKey: string;
  infoAggiuntivaKey: string;
  infoTipoScommessaId: string;
  gtagAction?: () => void;
};
export const RecursiveEsitoList = ({
  hasTitleHeader,
  scommessaKey,
  infoAggiuntivaKey,
  infoTipoScommessaId,
  gtagAction,
}: RecursiveEsitoListProps) => {
  const { numeroEsiti } = useInfoTipo(infoTipoScommessaId) ?? {};
  const isAvvenimento = useIsAvvenimento();
  const { isMobile } = useWindowSize();

  const esitoKeyList = useMemo(() => {
    // Il numero di esiti nella keyList potrebbe essere inferiore al totale,
    // quindi un semplice map su esitoKeyList potrebbe lasciare "buchi" nella tabella
    // per tanto genero una chiave che poi andrò a cercare nell'esitoMap e nel caso mettere quota o cella vuota
    return [...Array(numeroEsiti)].map((_, index) => `${infoAggiuntivaKey}-${index + 1}`);
  }, [infoAggiuntivaKey, numeroEsiti]);

  if (isTruthy(esitoKeyList?.length)) {
    return (
      <>
        {esitoKeyList.map((esitoKey) => (
          <ScommesseEsitoTipoBox
            key={esitoKey}
            showHeaderOutside={hasTitleHeader && !isMobile}
            //header={hasTitleHeader ? headers?.[index] : undefined}
            keyEsito={esitoKey}
            showHeader={hasTitleHeader}
            scommessaKey={scommessaKey}
            infoAggiuntivaKey={infoAggiuntivaKey}
            //headerTrKey={headersTrKey?.[index]}
            gtagAction={gtagAction}
            className={classNames({ [styles.containerAvvenimento]: isAvvenimento })}
            classNameButton={classNames({ [styles.boxAvvenimento]: isAvvenimento })}
          />
        ))}
      </>
    );
  }

  return <React.Fragment key={infoAggiuntivaKey} />;
};
